//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import {
  item_radio,
  item_checkbox,
  item_blank,
  item_image_single,
  item_image_multiple,
  item_dropdown_single,
  item_dropdown_multiple,
  item_select_multiple,
  item_blank_multiple,
  item_scale,
  item_sort,
  item_file,
  item_section,
  item_address,
  item_date,
  item_matrix_scale,
  item_proportion,
  item_activity_time,
  item_autograph,
  questionnaireSummary
} from './modules'
import { setQuestionLogicBlock } from '@/tools/index.js'
export default {
  data() {
    return {

    }
  },
  props: {
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false
    },
    answer: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    ...mapGetters(['questionnaireList', 'questionnaireReturnData']),
    indexList() {
      let temp = 0
      return this.questionnaireList.map((item) => {
        if (item.v_visible && item.displayIndex) {
          temp += 1
          return {
            index: temp
          }
        } else {
          return {
            index: ''
          }
        }
      })
    }
  },
  components: {
    item_radio,
    item_checkbox,
    item_blank,
    item_image_single,
    item_image_multiple,
    item_dropdown_single,
    item_dropdown_multiple,
    item_select_multiple,
    item_blank_multiple,
    item_scale,
    item_sort,
    item_file,
    item_section,
    item_address,
    item_date,
    item_matrix_scale,
    item_proportion,
    item_activity_time,
    item_autograph,
    questionnaireSummary
  },
  methods: {
    // 选择题选中
    onSelectChange(isCancel = false) {
      setQuestionLogicBlock(this.questionnaireList, isCancel)
    },
    async validateAnswer() {
      const promiseArray = []
      this.questionnaireList.forEach((q, index) => {
        // 有显示的验证
        if (q.v_visible) {
          const validate = this.$refs[`item${q.tenantId}`][0].validate()
          promiseArray.push(validate)
        }
      })
      const validate = await Promise.all(promiseArray)
      console.log(validate);
      return validate
    }
  }
}
